
import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import { Action, Getter } from 's-vuex-class'
import { TeamScoreboardEntity } from '@/entities/teamscoreboard'

@Component<TsNpsCurrentGroupV2>({})
export default class TsNpsCurrentGroupV2 extends Vue {
    @Getter public companyName
    @Getter public teamScoreboard
    @Getter public previousTeamScoreboard
    @Getter public siblingGroups

    @Action public popTsHierarchy
    @Action public switchTeamScoreboard

    public get backToText() {
        if (this.teamScoreboard?.parent?.field === this.teamScoreboard?.field) {
            return this.previousTeamScoreboard.fieldLabel
        }

        return this.previousTeamScoreboard.parentFieldLabel || this.companyName
    }

    public onClickBackTo() {
        let level = 1
        if (this.teamScoreboard?.parent?.field === this.teamScoreboard?.field) {
            level = 0
        }
        this.popTsHierarchy(level)
    }
}
